import { render } from "./Athlete_details.vue?vue&type=template&id=6144322a"
import script from "./Athlete_details.vue?vue&type=script&lang=js"
export * from "./Athlete_details.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__